/**
 * GameConstants.ts
 */
export class GameConstants {
}
GameConstants.PROPERTY_ROOM_NAME = "rn";
GameConstants.PROPERTY_REALITY_CHECK_INTERVAL = "realityCheckInterval";
GameConstants.PROPERTY_TOTAL_SESSION_TIME = "totalSessionTime";
GameConstants.PROPERTY_NEXT_REALITY_CHECK = "nextRealityCheck";
GameConstants.PROPERTY_PROGRESSIVE_JACKPOTS = "progressiveJackpots";
GameConstants.PROPERTY_PROGRESSIVE_JACKPOT_NAME = "progressiveJackpotName";
GameConstants.PROPERTY_PROGRESSIVE_JACKPOT_AMOUNT = "progressiveJackpotAmount";
GameConstants.PROPERTY_PROGRESSIVE_JACKPOT_PRIORITY = "progressiveJackpotPriority";
GameConstants.PROPERTY_PROGRESSIVE_JACKPOT_WIN_AMOUNT = "progressiveJackpotWinAmount";
GameConstants.PROPERTY_PROGRESSIVE_JACKPOT_STATUS = "progressiveJackpotStatus";
GameConstants.PROPERTY_TOTAL_LOSS = "totalLoss";
GameConstants.PROPERTY_TOTAL_WIN = "totalWin";
GameConstants.PROPERTY_SETTINGS = "settings";
GameConstants.PROPERTY_EXTRA_SPIN = "extraSpin";
GameConstants.PROPERTY_SPIN_PRICE = "spinPrice";
GameConstants.PROPERTY_SINGLE_GAME_STAKE = "singleGameStake";
GameConstants.PROPERTY_MAXIMUM_LOSS = "maximumLoss";
GameConstants.PROPERTY_HIDE_INSTRUCTIONS = "hideInstructions";
GameConstants.PROPERTY_ACTIVE_BALANCE = "activeBalance";
GameConstants.PROPERTY_POST_WAGER = "postWager";
GameConstants.PROPERTY_MAXIMUM_STAKE = "maximumStake";
GameConstants.PROPERTY_MAXIMUM_TOTAL_STAKE = "maximumTotalStake";
//# sourceMappingURL=GameConstants.js.map